import ApiRoot from '@http/ApiRoot';

export default async function (id) {
  try {
    const response = await ApiRoot.get(`/lottery/${id}`)
    return response;
  } catch (error) {
    console.error('getLottery', error)
    return new Error(error)
  }
}
